module.exports = __webpack_public_path__ + "static/media/indoor-outdoor-primary.0b1eef53.jpg";